<template>
  <v-layout align-center justify-center column class="pagemargin page">
    <notifications group="login" position="top center" />

    <v-progress-linear :active="loading" :indeterminate="loading" absolute bottom color="primary"></v-progress-linear>
    <v-spacer></v-spacer>

    <v-flex xs12 sm12 md12 align-center>
      <div style="border: black">
        <img
          :src="require('@/assets/colour-logo-transparent-bg.png')"
          style="max-width: 50%; margin-top: 40px"
        />
      </div>
    </v-flex>

    <v-progress-circular
    v-if="portalLoading"
      :active="portalLoading" :indeterminate="portalLoading"
      :size="90"
      :width="7"
      color="purple"
      style="margin-top: 15%"
    ></v-progress-circular>

    <v-card class="login" width="400" height="400" v-if="!portalLoading">
      <v-card-title class="title font-weight-regular justify-space-between">Sign in</v-card-title>

      <v-window>
        <v-window-item>
          <v-card-text>
            <v-text-field
              v-model.trim="userEmail"
              browser-autocomplete
              aria-autocomplete="list"
              label="Email"
              solo
              data-vv-name="userEmail"
              data-vv-rules="required"
              v-validate="'required|max:30'"
              :error-messages="errors.collect('userEmail')"
            ></v-text-field>

            <v-text-field
              :append-icon="show ? 'visibility' : 'visibility_off'"
              :rules="[rules.required, rules.min]"
              :type="show ? 'text' : 'password'"
              @click:append="show = !show"
              hint="At least 8 characters"
              v-model.trim="password"
              v-on:enter="login()"
              label="Password"
              solo
              data-vv-name="password"
              data-vv-rules="required"
              v-validate="'required|max:30'"
              :error-messages="errors.collect('password')"
            ></v-text-field>
          </v-card-text>
        </v-window-item>
      </v-window>

      <v-scale-transition>
        <v-card-actions v-if="!loading" class="acbutton">
          <v-btn
            color="primary"
            :disabled="errors.any()"
            @click="loading = true"
            block
            round
            class="acbutton"
          >Login</v-btn>
        </v-card-actions>
      </v-scale-transition>
      <v-card-text class="justify-center">
        <router-link :to="{ path: 'send-email'}" replace class="btn btn-link">Forgot password?</router-link>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import Vue from "vue";
import CRUD from "@/firebase/crud";
import axios from "axios";

export default {
  data() {
    return {
      portalLoading: true,
      loading: false,
      show: false,
      userEmail: "",
      password: "",
      submitted: false,
      rules: {
        required: value => !!value || "Required.",
        min: v => v.length >= 8 || "Min 8 characters"
      }
    };
  },
  watch: {
    portal: {
      handler: function () {
        //console.log("this.portal = " + JSON.stringify(this.portal, null, 2))
        if (this.portal.id !== undefined) {
          this.portalLoading = false;
          //console.log("portal id is "  + this.portal.id)
        } else {
          //console.log("portal id is null")
        }
      }, immediate: true
    },
    /*
    setThemeColor: {
      handler: function() {
        if (this.portalLoading ) {
          //console.log("this.$vuetify.theme.primary:" + this.$vuetify.theme.primary);          
          var domainURL = window.location.hostname;
          // console.log("location = " + JSON.stringify(window.location, null, 2))
          axios
            .get(
              window.location.origin + "/functions/getPortal?domainURL=" +
                domainURL
            )
            .then(response => {
              // console.log("response =" + JSON.stringify(response, null, 2));
              this.$store.commit("portal/setActive", response.data.result);
              // // console.log(
              //   "response.data.result = " +
              //     JSON.stringify(response.data.result, null, 2)
              // );
              //this.$vuetify.theme.primary = this.portal.primary;              
              this.portalLoading = false;
              // // console.log(
              //   "this.$vuetify.theme.primary=" + this.$vuetify.theme.primary
              // );
            });
          //bring the portal based on the domainURL ??
          //loading here then set the color primary
        }
      },
      immediate: true
    },
  */
    loading(val) {
      if (!val) return;

      setTimeout(() => (this.loading = false), 2000);
      this.login();
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      portal: state => state.portal.active
    })
  },
  methods: {
    login: function() {
      if (!this.loading) return;
      setTimeout(() => (this.loading = false), 3000);
      this.submitted = true;
      this.$firebase.auth
        .signInWithEmailAndPassword(this.userEmail, this.password)
        .then(
          user => {
            if (user.user.emailVerified != true) {
              this.$store.commit("user/setUserProfile", [
                "userID",
                user.user.uid
              ]);
              // // console.log(
              //   "user.user.emailVerified: " + user.user.emailVerified
              // );
              this.$router.push("/no-access");
            } else {
              // console.log("User logged in successfully");

              this.$store.commit("user/setUserProfile", [
                "userID",
                user.user.uid
              ]);

              let userDocument = Promise.resolve(
                CRUD.GetDocumentByID("users", user.user.uid)
              );

              userDocument.then(response => {
                this.$store.commit("user/setUserProfile", [
                  "userLevel",
                  response.data.userLevel
                ]);

                this.$store.commit("user/setUserProfile", [
                  "emailVerified",
                  response.data.emailVerified
                ]);

                this.$store.commit("user/setUserProfile", [
                  "fullName",
                  response.data.fullName
                ]);
                this.$store.commit("user/setUserProfile", [
                  "sponsorID",
                  response.data.sponsorID
                ]);

                //console.log("Is sponsor = " + response.data.isSponsor);
                if (response.data.isSponsor == true) {
                  this.$router.push("/sponsorsreport");
                } else this.$router.push("/charts");
              });
            }
          },
          err => {
            //alert("Oops. " + err.message);
            Vue.notify({
              group: "login",
              title: "Warning",
              text: "Email and password are incorrect",
              type: "warning",
              dismissible: "true"
            });
          }
        );
    }
  }
};
</script>

<style>
.login {
  margin: 3%;
  padding: 3%;
  border-radius: 10px !important;
}
</style>